import { TagData } from '@src/application/modules/tag/shared/tag/serializedTagTypes';
import { MSG_NAME_TO_IFRAME, sendMessageToIframe } from '../handleIframeMessage/handleIframeMessage';

export const pushTagData = (tagData: TagData) => {
  sendMessageToIframe({
    name: MSG_NAME_TO_IFRAME.QaAssistantTagData,
    tagData,
  });
};
